(function($, undefined) {
	'use strict';
	var utils;

	var init = function() {
		$('.folder-section__toggle-subnav-btn').click(toggleSubnav);
	};

	function toggleSubnav() {
		var btn = $(this);
		var ctn = btn.closest('.folder-section__nav-page');

		ctn.find('.folder-section__subnav').slideToggle(function() {
			ctn.toggleClass('folder-section__nav-page_subnav-open');
		});
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
